var REACT_ELEMENT_TYPE;function _jsx(type, props, key, children) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var defaultProps = type && type.defaultProps,childrenLength = arguments.length - 3;if (props || 0 === childrenLength || (props = { children: void 0 }), 1 === childrenLength) props.children = children;else if (childrenLength > 1) {for (var childArray = new Array(childrenLength), i = 0; i < childrenLength; i++) childArray[i] = arguments[i + 3];props.children = childArray;}if (props && defaultProps) for (var propName in defaultProps) void 0 === props[propName] && (props[propName] = defaultProps[propName]);else props || (props = defaultProps || {});return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: void 0 === key ? null : "" + key, ref: null, props: props, _owner: null };}function ownKeys(object, enumerableOnly) {var keys = Object.keys(object);if (Object.getOwnPropertySymbols) {var symbols = Object.getOwnPropertySymbols(object);enumerableOnly && (symbols = symbols.filter(function (sym) {return Object.getOwnPropertyDescriptor(object, sym).enumerable;})), keys.push.apply(keys, symbols);}return keys;}function _objectSpread(target) {for (var i = 1; i < arguments.length; i++) {var source = null != arguments[i] ? arguments[i] : {};i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {_defineProperty(target, key, source[key]);}) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));});}return target;}function _defineProperty(obj, key, value) {key = _toPropertyKey(key);if (key in obj) {Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });} else {obj[key] = value;}return obj;}function _toPropertyKey(arg) {var key = _toPrimitive(arg, "string");return typeof key === "symbol" ? key : String(key);}function _toPrimitive(input, hint) {if (typeof input !== "object" || input === null) return input;var prim = input[Symbol.toPrimitive];if (prim !== undefined) {var res = prim.call(input, hint || "default");if (typeof res !== "object") return res;throw new TypeError("@@toPrimitive must return a primitive value.");}return (hint === "string" ? String : Number)(input);}import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import Immutable, { is } from 'immutable';
import { Link } from 'react-router-dom';
import rison from 'rison-node';
import ShowIf from "../../App/ShowIf";
import { withRouter } from "../../componentWrappers";
import { searchParamsFromLocationSearch } from "../../utils/routeHelpers";
import { t, Translate } from "../../I18N";
import { Icon } from "../../UI";

import { filterDocumentTypes } from "../actions/filterActions";

const getItemsToShow = (fromFilters, templates, settings) => {var _items;
  let items = fromFilters ? settings.collection.toJS().filters : [];
  if (!((_items = items) !== null && _items !== void 0 && _items.length)) {
    items = templates.toJS().map((tpl) => ({
      id: tpl._id,
      name: tpl.name
    }));
  }
  return items;
};

class DocumentTypesList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      ui: {},
      serverSideRender: true
    };
  }

  componentDidMount() {
    this.setState({ serverSideRender: false });
  }

  shouldComponentUpdate(nextProps, nextState) {
    return (
      !is(this.props.selectedTemplates, nextProps.selectedTemplates) ||
      !is(this.props.settings, nextProps.settings) ||
      !is(this.props.aggregations, nextProps.aggregations) ||
      this.stateChanged(nextState));

  }

  changeAll(item, e) {
    const { selectedTemplates: selectedItems } = this.props;
    if (e.target.checked) {
      item.items.forEach((_item) => {
        if (!this.checked(_item)) {
          selectedItems.push(_item.id);
        }
      });
    }

    if (!e.target.checked) {
      item.items.forEach((_item) => {
        if (this.checked(_item)) {
          const index = selectedItems.indexOf(_item.id);
          selectedItems.splice(index, 1);
        }
      });
    }

    this.props.filterDocumentTypes(selectedItems, this.props.location, this.props.navigate);
  }

  change(item) {
    const { selectedTemplates: selectedItems } = this.props;

    if (selectedItems.includes(item.id)) {
      const index = selectedItems.indexOf(item.id);
      selectedItems.splice(index, 1);
    } else {
      selectedItems.push(item.id);
    }

    this.props.filterDocumentTypes(selectedItems, this.props.location, this.props.navigate);
  }

  toggleOptions(item, e) {
    e.preventDefault();
    if (!this.checked(item) && item.items.find((itm) => this.checked(itm))) {
      return;
    }
    const { ui } = this.state;
    ui[item.id] = !ui[item.id];
    this.setState({ ui });
  }

  aggregations(item) {
    const aggregations = this.aggs;
    const buckets =
    aggregations.all && aggregations.all._types ? aggregations.all._types.buckets : [];
    const found = buckets.find((agg) => agg.key === item.id);
    if (found) {
      return found.filtered.doc_count;
    }

    if (item.items) {
      return item.items.reduce((result, _item) => result + this.aggregations(_item), 0);
    }

    return 0;
  }

  showSubOptions(parent) {
    const toggled = this.state.ui[parent.id];
    return !!(toggled || !!(!this.checked(parent) && parent.items.find((itm) => this.checked(itm))));
  }

  checked(item) {
    if (item.items) {
      return item.items.reduce(
        (result, _item) => result && this.checked(_item),
        item.items.length > 0
      );
    }

    return this.props.selectedTemplates.includes(item.id);
  }

  stateChanged(nextState) {
    return (
      Object.keys(nextState.ui).length === Object.keys(this.state.ui).length ||
      Object.keys(nextState.ui).reduce(
        (result, key) => result || nextState.ui[key] === this.state.ui[key],
        false
      ));

  }

  optionUrl(value, query) {
    const q = rison.encode(_objectSpread(_objectSpread({},
    query), {}, {
      types: [value],
      from: 0,
      limit: 30,
      includeUnpublished: false,
      order: 'desc',
      sort: 'creationDate',
      unpublished: false,
      allAggregations: false })
    );
    return `/library/?q=${q}`;
  }

  renderSingleType(item, index) {
    const context = item.id === 'missing' ? 'System' : item.id;

    const query = searchParamsFromLocationSearch(this.props.location, 'q') || {
      filters: []
    };

    return /*#__PURE__*/(
      _jsx("li", { className: "multiselectItem", title: item.name }, index, /*#__PURE__*/
      _jsx("input", {
        type: "checkbox",
        className: "multiselectItem-input",
        value: item.id,
        id: item.id,
        onChange: this.change.bind(this, item),
        checked: this.checked(item) }
      ), /*#__PURE__*/
      _jsx("label", { className: "multiselectItem-label", htmlFor: item.id }, void 0, /*#__PURE__*/
      _jsx("span", { className: "multiselectItem-icon" }, void 0, /*#__PURE__*/
      _jsx(Icon, { icon: ['far', 'square'], className: "checkbox-empty" }), /*#__PURE__*/
      _jsx(Icon, { icon: "check", className: "checkbox-checked" })
      ), /*#__PURE__*/
      _jsx("span", { className: "multiselectItem-name" }, void 0,
      this.state.serverSideRender ? /*#__PURE__*/
      _jsx(Link, { to: this.optionUrl(item.id, query) }, void 0, /*#__PURE__*/
      _jsx(Translate, { context: context }, void 0, item.name)
      ) : /*#__PURE__*/

      _jsx(Translate, { context: context }, void 0, item.name)

      )
      ), "\xA0", /*#__PURE__*/

      _jsx("span", { className: "multiselectItem-results" }, void 0, this.aggregations(item))
      ));

  }

  renderGroupType(item, index) {
    return /*#__PURE__*/(
      _jsx("li", {}, index, /*#__PURE__*/
      _jsx("div", { className: "multiselectItem" }, void 0, /*#__PURE__*/
      _jsx("input", {
        type: "checkbox",
        className: "form-control multiselectItem-input",
        id: item.id,
        onChange: this.changeAll.bind(this, item),
        checked: this.checked(item) }
      ), /*#__PURE__*/
      _jsx("label", { htmlFor: item.id, className: "multiselectItem-label" }, void 0, /*#__PURE__*/
      _jsx("span", { className: "multiselectItem-icon" }, void 0, /*#__PURE__*/
      _jsx(Icon, { icon: ['far', 'square'], className: "checkbox-empty" }), /*#__PURE__*/
      _jsx(Icon, { icon: "check", className: "checkbox-checked" })
      ), /*#__PURE__*/
      _jsx("span", { className: "multiselectItem-name" }, void 0, /*#__PURE__*/
      _jsx("b", {}, void 0, t('Filters', item.name))
      )
      ), /*#__PURE__*/
      _jsx("span", { className: "multiselectItem-results" }, void 0, /*#__PURE__*/
      _jsx("span", {}, void 0, this.aggregations(item)), /*#__PURE__*/
      _jsx("span", { className: "multiselectItem-action", onClick: this.toggleOptions.bind(this, item) }, void 0, /*#__PURE__*/
      _jsx(Icon, { icon: this.state.ui[item.id] ? 'caret-up' : 'caret-down' })
      )
      )
      ), /*#__PURE__*/
      _jsx(ShowIf, { if: this.showSubOptions(item) }, void 0, /*#__PURE__*/
      _jsx("ul", { className: "multiselectChild is-active" }, void 0,
      item.items.map((_item, i) => this.renderSingleType(_item, i))
      )
      )
      ));

  }

  render() {
    const { fromFilters, templates, settings } = this.props;
    const items = getItemsToShow(fromFilters, templates, settings);
    this.aggs = this.props.aggregations.toJS();
    return /*#__PURE__*/(
      _jsx("ul", { className: "multiselect is-active" }, void 0,
      items.map((item, index) => {
        if (item.items) {
          return this.renderGroupType(item, index);
        }
        return this.renderSingleType(item, index);
      })
      ));

  }
}

DocumentTypesList.defaultProps = {
  fromFilters: true,
  templates: Immutable.fromJS([]),
  settings: {},
  aggregations: Immutable.fromJS({}),
  selectedTemplates: [],
  filterDocumentTypes: {}
};
















function mapStateToProps(state) {
  return {
    settings: state.settings,
    templates: state.templates,
    aggregations: state.library.aggregations
  };
}

//parent ts component requires ownProps to inferring types
function mapDispatchToProps(dispatch, _ownProps) {
  return bindActionCreators({ filterDocumentTypes }, dispatch);
}

export { DocumentTypesList, mapStateToProps };
export default connect(mapStateToProps, mapDispatchToProps)(withRouter(DocumentTypesList));